<template>
   <teleport to="body">
      <div>
         <button
            ref="btnModalRef"
            style="display: none"
            data-bs-toggle="modal"
            data-bs-target="#image-sources"
            id="popup-select-source-btn"
         />
         <div
            class="modal fade modal-custom"
            id="image-sources"
            tabindex="-1"
            role="dialog"
            aria-labelledby="image-sources"
            aria-hidden="true"
         >
            <div class="modal-dialog fixed-bottom" role="document">
               <div class="modal-custom__content">
                  <div class="modal-custom__header">
                     <span class="modal-custom__title">{{ $t('avatar.change_avatar') }}</span>
                     <span class="modal-custom__action" data-bs-dismiss="modal"
                        ><i class="icon-fonts icon-fonts--close"></i
                     ></span>
                  </div>
                  <div class="modal-custom__body">
                     <div class="image-source">
                        <div
                           class="image-source__item"
                           data-bs-dismiss="modal"
                           v-for="(s, index) in sources"
                           :key="index"
                           @click="$emit('select-source', s.name)"
                        >
                           <h5 class="image-source__name">{{ s.name }}</h5>
                           <i class="image-source__description">{{ s.description }}</i>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </teleport>
</template>
<script>
import i18n from '@/plugins/i18n'
import Teleport from 'vue2-teleport'
export default {
   components: { Teleport },
   data() {
      return {
         showedData: {},
         sources: [
            {
               name: i18n.t('avatar.library'),
               description: i18n.t('avatar.library_description'),
            },
            {
               name: i18n.t('avatar.camera'),
               description: ''
            }
         ]
      }
   },
   methods: {
      showModal() {
         this.$refs.btnModalRef.click()
      }
   },
}
</script>

<style lang="scss" scoped>
.modal-custom {
   &__content {
      position: relative;
      padding: 15px;
   }
   &__header {
      display: flex;
      justify-content: center;
   }

   &__action {
      position: absolute;
      top: 20px;
      right: 20px;
      height: 20px;
      width: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--bs-primary);
      border-radius: 50%;
      padding: 0;

      i {
         color: var(--bs-white);
         font-size: 15px;
         font-weight: bolder;
      }
   }

   &__title {
      font-size: 20px;
      font-weight: bold;
   }

   &__btn {
      margin: 30px 0 0;
      gap: 20px;

      .button {
         margin: 0;
         border: 1px solid var(--bs-primary);
         color: #000000;
         font-weight: bold;
         font-size: 15px;
         border-radius: 100px;
         height: 44px;

         &.button--primary {
            background: var(--bs-primary);
            color: var(--bs-white);
         }
      }
   }
}

.modal.fade .modal-dialog.fixed-bottom {
   position: fixed;
   bottom: 0;
   right: 0;
   top: unset;
   left: 0;
   transform: unset;
   margin: 0;

   .modal-custom__content {
      border-bottom-left-radius: unset;
      border-bottom-right-radius: unset;
   }
}

.image-source {
   border-radius: 30px;
   &__item {
      height: 60px;
      padding: 5px 15px;
      border: 1px solid rgba(229, 231, 235, var(--tw-border-opacity));
      border-radius: 15px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;

      &:first-of-type {
         margin-bottom: 20px;
      }
   }
   &__name {
      font-size: 14px;
      font-weight: bold;
      line-height: 24px;
   }
   &__description {
      color: var(--bs-gray-500);
   }
}
</style>
